import {ActionWithPayload} from '../helpers/reduxHelpers';
import {AppState} from './appState';
import {DataAction} from './data/dataActions';
import {DataState} from './data/dataState';
import {ElectronAction} from './electron/electronActions';
import {FeatureFlagsAction} from './featureFlags/featureFlagsActions';
import {MetadataAction} from './metadata/metadataActions';
import {OptimisticUpdatesAction} from './optimisticUpdates/optimisticUpdatesActions';
import {PanelsAction} from './panels/panelsActions';
import {PanelsState} from './panels/panelsState';
import {PushStatusAction} from './pushStatus/pushStatusActions';
import {UpdateAction} from './update/updateActions';

/*
 * Action types.
 */

export enum AppActionsEnum {
  // Stands for garbage collection.
  GC = '@@gc',
}

/*
 * Types.
 */

export interface GcAction extends ActionWithPayload<GcPayload> {
  type: AppActionsEnum.GC;
}

export interface GcPayload {
  data: DataState;
  panels: PanelsState;
}

/*
 * Action creators.
 */

export function applyGc(state: AppState): GcAction {
  return {
    type: AppActionsEnum.GC,
    payload: {
      // Garbage collection happens in the base data (see RAppState).
      data: state.originalData,
      panels: state.panels,
    },
  };
}

/** Union of all action types. */
export type AppAction =
  | DataAction
  | OptimisticUpdatesAction
  | MetadataAction
  | PanelsAction
  | GcAction
  | FeatureFlagsAction
  | ElectronAction
  | UpdateAction
  | PushStatusAction;
